import { defineMessages } from 'react-intl';

export default defineMessages({
    signIn: {
        id: 'auth.components.LockLogin.Sign In',
        defaultMessage: 'Sign In'
    },
    login: {
        id: 'auth.components.LockLogin.Login',
        defaultMessage: 'Login'
    },
    logout: {
        id: 'auth.components.LockLogin.Logout',
        defaultMessage: 'Logout'
    },
    username: {
         id: 'auth.components.LockLogin.Username/Email Address:',
        defaultMessage: 'Username/Email Address:'
    },
    password: {
        id: 'auth.components.LockLogin.Password:',
        defaultMessage: 'Password:'
    },
    fieldEmpty: {
        id: 'auth.components.LockLogin.Enter username and password to sign in.',
        defaultMessage: 'Enter username and password to sign in.'
    },
    fieldsIncorrect: {
        id: 'auth.components.LockLogin.Username or password is incorrect.',
    //    defaultMessage: 'Username or password is incorrect.'
        defaultMessage: 'Your authentication information is incorrect. Please try again'
    },
    invalidAttempt: {
        id: 'auth.components.LockLogin.Invalid login attempt.',
        defaultMessage: 'Invalid login attempt.'
    },
    forgotYourPassword: {
        id: 'auth.components.LockLogin.Forgot your password?',
        defaultMessage: 'Forgot your password?'
    },
    accountLocked: {
        id: 'auth.components.LockLogin.For security reasons your account is temporarily locked.',
        defaultMessage: 'For security reasons your account is temporarily locked.'
    },
    invalidVerificationCode: {
        id: 'auth.components.Invalid code entered. Please try again.',
        defaultMessage: 'Invalid code entered. Please try again.'
    },
    unableToSendToken: {
        id: 'auth.components.Unable to send verification code. Please try again after sometime.',
        defaultMessage: 'Unable to send verification code. Please try again after sometime.'
    },
    verificationText: {
        id: 'auth.components.We sent you 6 digit number at',
        defaultMessage: 'We sent you 6 digit number at {num}'
    },
    verificationTextWithOutNumber: {
        id: 'auth.components.We sent you 6 digit number at your registered number',
        defaultMessage: 'We sent you 6 digit number at your registered number'
    },
    verificationButton: {
        id: 'auth.components.Verify',
        defaultMessage: 'Verify'
    },
    resendCode: {
        id: 'auth.components.LockLogin.Did not get the code? Resend it',
        defaultMessage: 'Did not get the code? Resend it'
    },
    invalidCode: {
        id: 'auth.components.LockLogin.Please enter valid 6 digit number',
        defaultMessage: 'Please enter valid 6 digit number'
    },
    signUpLinkText: {
        id: 'auth.components.LockLogin.Not a member yet? Sign up',
        defaultMessage: 'Not a member yet? Sign up'
    },
    mfaInfoText:{
         id: 'auth.components.LockLogin.*Please note: Apple users must enter the verification code manually',
        defaultMessage: '*Please note: Apple users must enter the verification code manually'
    }
});
